module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100"
  }, [_c('div', {
    staticClass: "flex includes-container mt2 pv2 pr2 pl4 justify-between items-center",
    class: {
      'includes-container-open': _vm.includeOpen || _vm.open,
      pointer: !_vm.open
    },
    on: {
      "click": function (e) { return _vm.toggleInclude(e); }
    }
  }, [_c('span', {
    staticClass: "includes-text"
  }, [_vm._v("What's included?")]), _vm._v(" "), (!_vm.open) ? _c('img', {
    staticClass: "chevron",
    class: {
      'chevron-rotate': _vm.includeOpen
    },
    attrs: {
      "alt": "Chevron",
      "src": "/static/appicons/Chevron.svg"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column items-start justify-between plan-details-container ph4",
    class: {
      'plan-details-container-transition': _vm.includeOpen || _vm.open,
      'z-9': _vm.includeOpen || _vm.open,
    }
  }, [_c('div', {
    staticClass: "plan-details-container-text inter",
    class: {
      'plan-details-container-text-transition': _vm.includeOpen || _vm.open
    }
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.description) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, _vm._l((_vm.planData), function(planInfoString, index) {
    return _c('div', {
      key: index,
      staticClass: "ph1 pb1 flex items-center col-cus-6 mt3"
    }, [_c('img', {
      staticClass: "pr2",
      attrs: {
        "alt": "✓",
        "height": "11",
        "src": "/static/appicons/Check.svg"
      }
    }), _vm._v("\n          " + _vm._s(planInfoString) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('hr', {
    staticClass: "line",
    class: {
      'line-transition': _vm.includeOpen || _vm.open
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row plan-details-container-text justify-between mb2 w-100 inter pv1",
    class: {
      'plan-details-container-text-transition': _vm.includeOpen || _vm.open
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between pl1 flex-column"
  }, [_c('h2', {
    staticClass: "cera-med nowrap mb0 lh-solid"
  }, [_vm._v("\n            +$" + _vm._s(_vm.planCostDifference) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "mh2"
  }, [_vm._v("per month")])]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center pr1 justify-end flex-column"
  }, [_c('div', {
    staticClass: "pr1"
  }, [_vm._v(_vm._s(_vm.planDeductibleRange))]), _vm._v(" "), _c('div', [_vm._v("deductibles")])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-109660e5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-109660e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upgrade-plan/UpgradePlanInfo.vue
// module id = 1464
// module chunks = 0